const {Component} = require("react");
const PropTypes = require("prop-types");
const hammer = require("helpers/hammer");
const $ = require("helpers/element");
const Image = require("components/mixins/Image");
const router = require("services/router");

class CloseTrigger extends Component {

	static get propTypes() {
		return {
			targetSelector: PropTypes.string.isRequired,
			targetClassName: PropTypes.string.isRequired,
			className: PropTypes.string,
			attachTo: PropTypes.array,
			attachToKeyboard: PropTypes.bool
		};
	}

	static get defaultProps() {
		return {
			attachToKeyboard: true
		}
	}

	componentDidMount() {
		// Attach to other elements
		if (this.props.attachTo instanceof Array) {
			this.props.attachTo.forEach(selector => {
				const element = document.querySelector(selector);

				if (element == undefined) {
					return;
				}

				element.addEventListener("click", () => this.updateTarget());
				//hammer(element).on("tap", () => this.updateTarget());
			});
		}

		// Attach to keyboard (on escape)
		if (this.props.attachToKeyboard) {
			document.addEventListener("keyup", e => {
				if ((e.keyCode || e.which) === 27) {
					this.updateTarget();
				}
			});
		}
	}

	updateTarget() {
		const element = document.querySelector(this.props.targetSelector);

		if (element == undefined) {
			return;
		}

		$(element).setClass(this.props.targetClassName, false);
	}

	_onClick = e => {
		e.preventDefault();
		e.stopPropagation();

		this.updateTarget();
	};

	render() {
		return (
			<div className={this.props.className} onClick={this._onClick}>
				<Image src={router.url("img/icons/close-white.svg")} alt="Close" scale={false}/>
			</div>
		);
	}

}

module.exports = CloseTrigger;



// WEBPACK FOOTER //
// ./resources/js/components/mixins/CloseTrigger.js